import React, { useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import Link from '@material-ui/icons/Link'
import Spinner from '../components/Spinner'
import ItemcardRepository from '../components/ItemCardRepository'
import ItemActionButtonExternalLink from '../components/ItemActionButtonExternalLink'

import { SET_SEARCH_ITEM } from '../actions/actionTypes'
import { itemRepositoryService } from '../services/repositoryService'

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
      padding: 10,
    },
    container: {
        padding: 10,
    },    
    button: {
        marginTop: 10,
        width: '100%',
    },
}));

export default function SearchResult(props) {
    const classes = useStyles()
    const dispatch = useDispatch()
    const itemState = useSelector(state => state.item)
    const [openToast, setOpenToast] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const fetchItem = itemId => {
        itemRepositoryService(itemId)
        .then(({data}) => {
            dispatch({ type: SET_SEARCH_ITEM, payload: data })
            setIsLoading(false)
        })
        .catch(() => {
            setOpenToast(true)
            setIsLoading(false)
        })
    }

    useEffect(() => {
        if(props.location.state)
            setOpenToast(!!props.location.state.error)

        if(!props.match.params.id)
            return

        if(itemState.item && itemState.item.id != props.match.params.id) {
            fetchItem(props.match.params.id)
        } else {
            setIsLoading(false)
        }
        
    // eslint-disable-next-line react-hooks / exhaustive-deps
    }, [])

    const BackButton = () => (
        <Grid item xs={12}>
            <Button 
                variant="outlined" 
                color="primary" 
                fullWidth={true}
                onClick={() => props.history.goBack()}>
                    Voltar
            </Button>
        </Grid>
    )

    return (
        <div className={classes.root}>
            <Grid container justify="center" spacing={3}>
                {isLoading && <Spinner />}
                
                {!isLoading && !openToast &&
                    <Grid item xs md={6} lg={4}>
                        <ItemcardRepository item={itemState.item} />

                        <Grid item container spacing={1}>
                            <Grid item xs={12}>
                                <ItemActionButtonExternalLink 
                                    url={itemState.item.uri}
                                    icon={<Link />}
                                    text="Acessar" />
                            </Grid>
                            
                            <BackButton />
                        </Grid>
                    </Grid>
                }
                <Snackbar
                    open={openToast}
                    autoHideDuration={5000}
                    message="Ocorreu um erro de rede. Por favor tente novamente em alguns instantes"
                    onClose={(event, reason) => setOpenToast(false)}
                />
                {openToast && <BackButton />}
            </Grid>
        </div>
    );
}